export const ADD = `ADD_MESSAGE`;
export const REMOVE = `REMOVE_MESSAGE`;

export const DISSMISS_INTERVAL = 5000;

export const SET_LAYOUT_CONFIG = 'SET_LAYOUT_CONFIG';
export const SET_USER_THEME_OPTIONS = 'SET_USER_THEME_OPTIONS';
export const SET_DEFAULT_THEME = 'SET_DEFAULT_THEME';
export const SET_AVAILABLE_LOCALES = 'SET_AVAILABLE_LOCALES';
export const SET_QUERY_LOCALE = 'SET_QUERY_LOCALE';
